module.exports = __webpack_public_path__ + "static/f10-68274607951094d57583739add1e1abc.jpeg";